
<div>
  <slot name="pageHeader">
    <PageHeader :underline="headerUnderline">
      <PageTitle
        :pre-title="preTitle"
        :title="title"
        :extra-title="extraTitle"
        :under-title="underTitle"
      >
        <slot name="pageActions" />
      </PageTitle>

      <HeaderNav v-if="tabFilter">
        <b-nav-item
          v-for="(tab, key) in filteredTabOptions"
          :key="key"
          :active="
            $route.params.tab === tab.value ||
            (!$route.params.tab && tab.default)
          "
          @click="changeTab(tab)"
        >
          <b-badge v-if="tab.beforeTabTitle" variant="soft-danger" pill>
            {{ tab.beforeTabTitle }}
          </b-badge>

          {{ __(tab.label) }}

          <b-badge
            v-if="tab.count && parseInt(tab.count) > 0"
            :data-testid="`${tab.value}-count`"
            variant="soft-secondary"
            pill
          >
            {{ tab.count }}
          </b-badge>
        </b-nav-item>
      </HeaderNav>
    </PageHeader>
  </slot>

  <template v-if="$slots.pageHeader">
    <div>
      <TableTopNav v-if="tabFilter && !inlineFilters">
        <b-nav-item
          v-for="(tab, key) in filteredTabOptions"
          :key="key"
          link-classes="nav-link-sm"
          :active="
            $route.params.tab === tab.value ||
            (!$route.params.tab && tab.default)
          "
          @click="changeTab(tab)"
        >
          {{ __(tab.label) }}

          <b-badge
            v-if="tab.count && parseInt(tab.count) > 0"
            variant="soft-secondary"
            pill
          >
            {{ tab.count }}
          </b-badge>
        </b-nav-item>
      </TableTopNav>
    </div>
  </template>

  <DataList
    v-if="list"
    :ref="id"
    :fetch-callback="fetchCallback"
    :default-sort="defaultSort"
    :model="model"
    :filters="filters"
    :has-filters="hasFilters"
    :selectable="selectable"
    :selected-rows="selectedRows"
    :show-footer="showFooter"
    :custom-list-group="customListGroup"
    @filterResetCalled="resetFilters"
    @tabCountsUpdateCalled="updateTabCounts"
    @breadcrumbsUpdateCalled="updateBreadcrumbs"
    @rowSelected="rowSelected"
  >
    <template #tableBreadcrumbs>
      <FilesBreadcrumbs :prefix="breadcrumbsPrefix" :items="breadcrumbs" />
    </template>

    <template #tableHeaderActions>
      <slot name="tableHeaderActions" />
    </template>

    <template #filters>
      <slot name="filters" />
    </template>

    <template #actionsPopover>
      <slot name="actionsPopover" />
    </template>

    <template #icon="{ item }">
      <slot name="icon" :item="item" />
    </template>

    <template #iconBlock="{ item }">
      <slot name="iconBlock" :item="item" />
    </template>

    <template #badge="{ item }">
      <slot name="badge" :item="item" />
    </template>

    <template #label="{ item }">
      <slot name="label" :item="item" />
    </template>

    <template #description="{ item }">
      <slot name="description" :item="item" />
    </template>

    <template #actionButtons="{ item }">
      <slot name="actionButtons" :item="item" />
    </template>

    <template #afterItem="{ item }">
      <slot name="afterItem" :item="item" />
    </template>

    <template #childItem="{ item }">
      <slot name="childItem" :item="item" />
    </template>

    <template #listGroupItem="{ item }">
      <slot name="listGroupItem" :item="item" />
    </template>
  </DataList>

  <DataTable
    v-else
    :id="id"
    :ref="id"
    :columns="columns"
    :fetch-callback="fetchCallback"
    :model="model"
    :default-sort="defaultSort"
    :filters="filters"
    :has-filters="hasFilters"
    :inline-filters="inlineFilters"
    :has-row-actions="hasRowActions"
    :selectable="selectable"
    :selected-rows="selectedRows"
    :headless="headless"
    :action-popover-condition="actionPopoverCondition"
    :table-class="tableClass"
    :mutate-data="mutateData"
    :is-pagination-links-visible="isPaginationLinksVisible"
    :row-click-handler="rowClickHandler"
    @filterResetCalled="resetFilters"
    @tabCountsUpdateCalled="updateTabCounts"
    @rowSelected="rowSelected"
  >
    <template #actionsPopover>
      <slot name="actionsPopover" />
    </template>

    <template #filters>
      <slot name="filters" />
    </template>

    <template #actionButtons="{ item }">
      <slot name="actionButtons" :item="item" />
    </template>

    <template #tableHeaderActions>
      <slot name="tableHeaderActions" />
    </template>

    <template v-for="column in columns" #[column.column]="{ item }">
      <slot :name="column.column" :item="item" />
    </template>

    <template #afterItem="{ item }">
      <slot name="afterItem" :item="item" />
    </template>

    <template #childItem="{ item }">
      <slot name="childItem" :item="item" />
    </template>

    <template #tfoot="meta">
      <slot name="tfoot" :meta="meta" />
    </template>
  </DataTable>
</div>
